export const AMAZONPAY_SCRIPT_LOAD_STATUS = 'AMAZONPAY_SCRIPT_LOAD_STATUS';
export const SET_SITE_VALUES = 'SET_SITE_VALUES';
export const SET_RETURN_HOST_PAYMENT = 'SET_RETURN_HOST_PAYMENT';
export const SET_ORDER_IS_PROCESSING = 'SET_ORDER_IS_PROCESSING';
export const SET_APPLEPAY_SESSION_STARTED = 'SET_APPLEPAY_SESSION_STARTED';
export const SET_WECHAT_PROCESSED = 'SET_WECHAT_PROCESSED';
export const SET_LANG = 'SET_LANG';
export const MERGE_LANG = 'MERGE_LANG';
export const UPDATE_START = 'UPDATE_START';

export const SET_SOCIAL_SHARING = 'SET_SOCIAL_SHARING';
export const SET_ORDER_COMPLETE = 'SET_ORDER_COMPLETE';

/* acknowledged message */
export const UPDATE_ACKNOWLEDGED_MESSAGE = 'UPDATE_ACKNOWLEDGED_MESSAGE';

/* Delivery Section */
export const UPDATE_PUDO_STATUS = 'UPDATE_PUDO_STATUS';
export const UPDATE_DELIVERY_TYPE = 'UPDATE_DELIVERY_TYPE';
export const UPDATE_VALID_STATUS = 'UPDATE_VALID_STATUS';

/* address */
export const BILLING_ADDRESS_SET_COUNTRIES = 'BILLING_ADDRESS_SET_COUNTRIES';
export const BILLING_ADDRESS_UPDATE = 'BILLING_ADDRESS_UPDATE';
export const BILLING_ADDRESS_OVERWRITE = 'BILLING_ADDRESS_OVERWRITE';

export const DELIVERY_ADDRESS_SET_COUNTRIES = 'DELIVERY_ADDRESS_SET_COUNTRIES';
export const DELIVERY_ADDRESS_SELECT = 'DELIVERY_ADDRESS_SELECT';
export const DELIVERY_ADDRESS_ADD = 'DELIVERY_ADDRESS_ADD';
export const DELIVERY_ADDRESS_UPDATE_FIELD = 'DELIVERY_ADDRESS_UPDATE_FIELD';
export const DELIVERY_ADDRESS_UPDATE_FIELD_OF_SELECTED_ADDRESS = 'DELIVERY_ADDRESS_UPDATE_FIELD_OF_SELECTED_ADDRESS';
export const DELIVERY_ADDRESS_UPDATE_FIELDS = 'DELIVERY_ADDRESS_UPDATE_FIELDS';
export const DELIVERY_ADDRESS_OVERWRITE = 'DELIVERY_ADDRESS_OVERWRITE';
export const DELIVERY_ADDRESS_UPDATE_CONTACT_NUMBER = 'DELIVERY_ADDRESS_UPDATE_CONTACT_NUMBER';
export const ADDRESS_UPDATE_CONTACT_NUMBER = 'ADDRESS_UPDATE_CONTACT_NUMBER';
export const POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS = 'POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS';

export const DELIVERY_ADDRESS_UPDATE_FIELD_IN_OVERLAY = 'DELIVERY_ADDRESS_UPDATE_FIELD_IN_OVERLAY';
export const UPDATE_EDITED_ADDRESS = 'UPDATE_EDITED_ADDRESS';
export const RESET_EDITED_ADDRESS = 'RESET_EDITED_ADDRESS';
export const SET_ADDRESS_AS_EDITED = 'SET_ADDRESS_AS_EDITED';
export const RESET_DELIVERY_ADDRESSES = 'RESET_DELIVERY_ADDRESSES';
export const SHOULD_SHOW_SPINNER = 'SHOULD_SHOW_SPINNER';
export const SET_ADDRESS_ENTRY_TYPE = 'SET_ADDRESS_ENTRY_TYPE';

export const USE_DELIVERY_ADDRESS_FOR_BILLING = 'USE_DELIVERY_ADDRESS_FOR_BILLING';
export const UPDATE_BILLING_ADDRESS_BY_PAYMENT_METHOD = 'UPDATE_BILLING_ADDRESS_BY_PAYMENT_METHOD';
export const OVERWRITE_BILLING_ADDRESS_BY_PAYMENT_METHOD = 'OVERWRITE_BILLING_ADDRESS_BY_PAYMENT_METHOD';
export const INITIALISE_BILLING_ADDRESS = 'INITIALISE_BILLING_ADDRESS';
export const INITIALISE_BILLING_ADDRESS_BY_PAYMENT_OPTION_TYPE = 'INITIALISE_BILLING_ADDRESS_BY_PAYMENT_OPTION_TYPE';
export const POSTCODE_ANYWHERE_SHOW_FIELDS = 'POSTCODE_ANYWHERE_SHOW_FIELDS';
export const ADDRESS_LOOKUP_USE_DELIVERY_RESULT = 'DELIVERY_ADDRESS_LOOKUP_USE_DELIVERY_RESULT';
export const ADDRESS_LOOKUP_USE_BILLING_RESULT = 'DELIVERY_ADDRESS_LOOKUP_USE_BILLING_RESULT';
export const UPDATE_RESIDENT_ID_PROPERTY = 'UPDATE_RESIDENT_ID_PROPERTY';
export const EXPRESS_CHECKOUT_RETURNED_ADDRESS = 'EXPRESS_CHECKOUT_RETURNED_ADDRESS';

/* Payment */
export const UPDATE_NEW_CARD_DETAILS = 'UPDATE_NEW_CARD_DETAILS';
export const UPDATE_KLARNA_DETAILS = 'UPDATE_KLARNA_DETAILS';
export const UPDATE_CV2_DETAILS = 'UPDATE_CV2_DETAILS';
export const SET_PAYMENT_OPTIONS = 'SET_PAYMENT_OPTIONS';
export const ADD_PAYMENT_OPTIONS_TO_STATE = 'ADD_PAYMENT_OPTIONS_TO_STATE';
export const SET_PAYMENT_CATEGORY = 'SET_PAYMENT_CATEGORY';
export const SET_PAYMENT_OPTIONS_FOR_CATEGORY = 'SET_PAYMENT_OPTIONS_FOR_CATEGORY';
export const SET_SHOULD_SHOW_PAYMENT_CATEGORY_SELECT_BOXES = 'SET_SHOULD_SHOW_PAYMENT_CATEGORY_SELECT_BOXES';
export const SET_AVAILABLE_PAYMENT_CATEGORIES = 'SET_AVAILABLE_PAYMENT_CATEGORIES';
export const SET_SHOULD_JUMP_TO_APM_HEADING = 'SET_SHOULD_JUMP_TO_APM_HEADING';
export const SET_PAYMENT_OPTION_ERROR_MESSAGE = 'SET_PAYMENT_OPTION_ERROR_MESSAGE';
export const SET_TRANSLATED_PAYMENT_OPTION_ERROR_MESSAGE = 'SET_TRANSLATED_PAYMENT_OPTION_ERROR_MESSAGE';
export const SET_CREDIT_ZERO_ORDER = 'SET_CREDIT_ZERO_ORDER';

export const SET_PAYMENT_OPTION_INDEX = 'SET_PAYMENT_OPTION_INDEX';
export const SET_SUB_PAYMENT_OPTION_INDEX = 'SET_SUB_PAYMENT_OPTION_INDEX';

export const SET_GOOGLE_AVAILABLE = 'SET_GOOGLE_AVAILABLE';
export const SET_GOOGLE_PAY_PAYMENT_DATA = 'SET_GOOGLE_PAY_PAYMENT_DATA';

export const SET_APPLEPAY_AVAILABLE = 'SET_APPLEPAY_AVAILABLE';

export const UPDATE_SHOULD_STORE_PAYMENT_DETAILS_CONSENT = 'UPDATE_SHOULD_STORE_PAYMENT_DETAILS_CONSENT';
export const SET_OPTIONAL_PAYMENT_DETAILS_CONSENT_CONFIGURATION = 'SET_OPTIONAL_PAYMENT_DETAILS_CONSENT_CONFIGURATION';

export const UPDATE_IS_PAYMENT_CONTAINER_COLLAPSED = 'UPDATE_IS_PAYMENT_CONTAINER_COLLAPSED';

export const UPDATE_SHOULD_SHOW_THREEDS_CHALLENGE_IFRAME = 'UPDATE_SHOULD_SHOW_THREEDS_CHALLENGE_IFRAME';

export const SET_PAYMENT_OPTIONS_LOADING_STATUS = 'SET_PAYMENT_OPTIONS_LOADING_STATUS';

/* PUDO */
export const ACTIVATE_ADD_COLLECTION_POINT_SUCCESS = 'ACTIVATE_ADD_COLLECTION_POINT_SUCCESS';
export const DEACTIVATE_ADD_COLLECTION_POINT_SUCCESS = 'DEACTIVATE_ADD_COLLECTION_POINT_SUCCESS';
export const DISPLAY_ALL_COLLECTION_POINTS_DEFAULT_ZOOM = 'DISPLAY_ALL_COLLECTION_POINTS_DEFAULT_ZOOM';
export const UPDATE_MAP_ZOOM = 'UPDATE_MAP_ZOOM';
export const HIDE_ADD_COLLECTION_POINT_SUCCESS = 'HIDE_ADD_COLLECTION_POINT_SUCCESS';

export const SET_COLLECTION_POINT_LOADING = 'SET_COLLECTION_POINT_LOADING';

export const LOAD_PUDO_SAVED_ADDRESSES_SUCCESS = 'LOAD_PUDO_SAVED_ADDRESSES_SUCCESS';
export const ADD_PUDO_ADDRESS_SUCCESS = 'ADD_PUDO_ADDRESS_SUCCESS';
export const CHANGE_PUDO_ADDRESS_SUCCESS = 'CHANGE_PUDO_ADDRESS_SUCCESS';

export const GET_PUDO_COLLECTION_POINTS_SUCCESS = 'GET_PUDO_COLLECTION_POINTS_SUCCESS';
export const UPDATE_PUDO_CURRENT_POSITION_SUCCESS = 'UPDATE_PUDO_CURRENT_POSITION_SUCCESS';
export const ENTER_COLLECTION_POINT = 'ENTER_COLLECTION_POINT';
export const MAKE_ACTIVE_COLLECTION_POINT = 'MAKE_ACTIVE_COLLECTION_POINT';
export const UPDATE_SELECTED_ACTIVE_COLLECTION_POINT = 'UPDATE_SELECTED_ACTIVE_COLLECTION_POINT';
export const UPDATE_SELECTED_COLLECTION_POINT = 'UPDATE_SELECTED_COLLECTION_POINT';
export const UPDATE_HAS_COLLECTION_POINTS = 'UPDATE_HAS_COLLECTION_POINTS';
export const UPDATE_COLLECTION_POINTS_AMOUNT_TO_DISPLAY = 'UPDATE_COLLECTION_POINTS_AMOUNT_TO_DISPLAY';
export const UPDATE_COLLECTION_POINTS_TO_DISPLAY = 'UPDATE_COLLECTION_POINTS_TO_DISPLAY';

export const ACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS = 'ACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS';
export const DEACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS = 'DEACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS';
export const DISPLAY_COLLECTION_POINT_SUCCESS = 'DISPLAY_COLLECTION_POINT_SUCCESS';

export const SET_DISPLAY_COLLECTOR_NAME_STATUS = 'SET_DISPLAY_COLLECTOR_NAME_STATUS';
export const SET_COLLECTOR_NAME = 'SET_COLLECTOR_NAME';

export const UPDATE_COLLECTION_POINTS = 'UPDATE_COLLECTION_POINTS';
export const SET_FILTER_COLLECTION_POINTS_SUCCESS = 'SET_FILTER_COLLECTION_POINTS_SUCCESS';
export const SET_DISPLAY_FILTERS_STATUS = 'SET_DISPLAY_FILTERS_STATUS';
export const SET_FILTER_VALUES_TO_DEFAULT = 'SET_FILTER_VALUES_TO_DEFAULT';

export const SET_DISPLAY_LIST_VIEW_STATUS = 'SET_DISPLAY_LIST_VIEW_STATUS';

export const INIT_PUDO_GOOGLE_MAPS_SUCCESS = 'LOAD_PUDO_GOOGLE_MAPS_SUCCESS';
export const SET_GOOGLE_MAPS_LOADING = 'SET_GOOGLE_MAPS_LOADING';

export const SET_INITIAL_COLLECTION_POINTS = 'SET_INITIAL_COLLECTION_POINTS';

/* New Collection */
export const SET_COLLECTION_MAP_ZOOM = 'SET_COLLECTION_MAP_ZOOM';
export const SET_CURRENT_SELECTED_LOCATION_SUCCESS = 'SET_CURRENT_SELECTED_LOCATION_SUCCESS';
export const SET_HAS_COLLECTION_LOCATIONS_STATUS = 'SET_HAS_COLLECTION_LOCATIONS_STATUS';
export const SET_COLLECTION_LOCATIONS = 'SET_COLLECTION_LOCATIONS';
export const SET_DISPLAY_COLLECTION_LOCATION_INFO = 'SET_DISPLAY_COLLECTION_LOCATION_INFO';
export const SET_HIDE_COLLECTION_LOCATION_INFO = 'SET_HIDE_COLLECTION_LOCATION_INFO';
export const SET_DISPLAY_COLLECTION_COLLECTOR_NAME = 'SET_DISPLAY_COLLECTION_COLLECTOR_NAME';
export const SET_HIDE_COLLECTION_COLLECTOR_NAME = 'SET_HIDE_COLLECTION_COLLECTOR_NAME';
export const SET_COLLECTION_COLLECTOR_NAME = 'SET_COLLECTION_COLLECTOR_NAME';
export const SET_COLLECTION_SEARCH_DESCRIPTION = 'SET_COLLECTION_SEARCH_DESCRIPTION';
export const SET_COLLECTION_LOCATIONS_TO_DISPLAY = 'SET_COLLECTION_LOCATIONS_TO_DISPLAY';

/* Delivery Option */
export const UPDATE_SELECTED_OPTION_INDEX = 'UPDATE_SELECTED_OPTION_INDEX';
export const UPDATE_SELECTED_NAMED_DAY_INDEX = 'UPDATE_SELECTED_NAMED_DAY_INDEX';
export const ENABLE_PRODUCT_PREVIEW = 'ENABLE_PRODUCT_PREVIEW';
export const DISABLE_PRODUCT_PREVIEW = 'DISABLE_PRODUCT_PREVIEW';
export const UPDATE_DELIVERY_OPTIONS = 'UPDATE_DELIVERY_OPTIONS';
export const UPDATE_FOCUS_ITEM = 'UPDATE_FOCUS_ITEM';
export const UPDATE_DELIVERY_OPTION_STATUS = 'UPDATE_DELIVERY_OPTION_STATUS';
export const RESET_DELIVERY_OPTIONS = 'RESET_DELIVERY_OPTIONS';
export const UPDATE_OPTIONAL_GROUP_USED = 'UPDATE_OPTIONAL_GROUP_USED';
export const UPDATE_DELIVERY_COUNTRY = 'UPDATE_DELIVERY_COUNTRY';

/* Order Summary */
export const UPDATE_ORDER_SUMMARY = 'UPDATE_ORDER_SUMMARY';
export const SET_ORDER_SUMMARY_UPDATING = 'SET_ORDER_SUMMARY_UPDATING';
export const SET_ORDER_SUMMARY_ERROR = 'SET_ORDER_SUMMARY_ERROR';
export const SET_ACCOUNT_CREDIT_MESSAGE = 'SET_ACCOUNT_CREDIT_MESSAGE';

/* Klarna */
export const SET_KLARNA_STATUS = 'SET_KLARNA_STATUS';
export const SET_KLARNA_ERROR = 'SET_KLARNA_ERROR';
export const SET_KLARNA_SESSION = 'SET_KLARNA_SESSION';
export const SET_LOAD_KLARNA_CATEGORY_RESPONSE = 'SET_LOAD_KLARNA_CATEGORY_RESPONSE';
export const SET_AUTH_KLARNA_CATEGORY_RESPONSE = 'SET_AUTH_KLARNA_CATEGORY_RESPONSE';
export const SET_KLARNA_CUSTOMER_DETAILS = 'SET_KLARNA_CUSTOMER_DETAILS';

/* ZipPay */
export const UPDATE_ZIPPAY_FORM = 'UPDATE_ZIPPAY_FORM';

/* ALipay Plus */
export const UPDATE_ALIPAY_PLUS_WALLET_DETAILS = 'UPDATE_ALIPAY_PLUS_WALLET_DETAILS';

/* Spotii */
export const UPDATE_SPOTII_FORM = 'UPDATE_SPOTII_FORM';

/* Arvato */
export const UPDATE_ARVATO_FORM = 'UPDATE_ARVATO_FORM';
export const UPDATE_ARVATO_LOADING = 'UPDATE_ARVATO_LOADING';
export const UPDATE_ARVATO_OPTIONS = 'UPDATE_ARVATO_OPTIONS';
export const USE_DELIVERY_ADDRESS_FOR_BILLING_ARVATO = 'USE_DELIVERY_ADDRESS_FOR_BILLING_ARVATO';

/* Openpay */
export const UPDATE_OPENPAY_FORM = 'UPDATE_OPENPAY_FORM';

/* Newpay */
export const SET_NEWPAY_SESSION_DATA = 'SET_NEWPAY_SESSION_DATA';
export const SET_NEWPAY_WALLET = 'SET_NEWPAY_WALLET';
export const SET_NEWPAY_SCRIPT_FAILURE = 'SET_NEWPAY_SCRIPT_FAILURE';

/* Overlay */
export const SET_OVERLAY = 'SET_OVERLAY';
export const CLEAR_OVERLAY = 'CLEAR_OVERLAY';
export const SET_SHOULD_PAUSE_FOCUS_TRAP = 'SET_SHOULD_PAUSE_FOCUS_TRAP';

/* Tooltip */
export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';

/* Page error */
export const SET_PAGE_MESSAGE = 'SET_PAGE_MESSAGE';
export const REMOVE_PAGE_MESSAGE = 'REMOVE_PAGE_MESSAGE';

/* UI */
export const SET_SCREEN_DIMENSIONS = 'SET_SCREEN_DIMENSIONS';
export const SET_CHECKOUT_PROGRESS_STEP = 'SET_CHECKOUT_PROGRESS_STEP';
export const UPDATE_SECTION_ORDER = 'UPDATE_SECTION_ORDER';
export const UPDATE_SUBSCRIPTION_SECTION_ORDER = 'UPDATE_SUBSCRIPTION_SECTION_ORDER';
export const REVERT_SECTION_ORDER = 'REVERT_SECTION_ORDER';

/* ACCESSIBILITY */
export const SET_MAIN_CONTENT_FOCUSED = 'SET_MAIN_CONTENT_FOCUSED';

/* THEME */
export const SET_THEME = 'SET_THEME';

/* BACKGROUND */
export const SET_BANNER_BACKGROUND_DESKTOP = 'SET_BANNER_BACKGROUND_DESKTOP';
export const SET_BANNER_BACKGROUND_MOBILE = 'SET_BANNER_BACKGROUND_MOBILE';

/* EMAIL */
export const SET_MARKETING_PREFERENCE = 'SET_MARKETING_PREFERENCE';
export const SET_SHOW_MARKETING_PREFERENCE = 'SET_SHOW_MARKETING_PREFERENCE';
export const UPDATE_EMAIL_ADDRESS = 'UPDATE_EMAIL_ADDRESS';

/* CREATE ACCOUNT */
export const SET_CREATE_ACCOUNT_STATUS = 'SET_CREATE_ACCOUNT_STATUS';
export const UPDATE_CREATE_ACCOUNT_DETAILS = 'UPDATE_CREATE_ACCOUNT_DETAILS';

/* NETWORK */
export const NETWORK_REQUEST_BEGUN = 'NETWORK_REQUEST_BEGUN';
export const NETWORK_REQUEST_FINISHED = 'NETWORK_REQUEST_FINISHED';

/* 3D SECURE */
export const INITIATE_DEVICE_DATA_COLLECTION = 'INITIATE_DEVICE_DATA_COLLECTION';
export const DEVICE_DATA_COLLECTION_COMPLETE = 'DEVICE_DATA_COLLECTION_COMPLETE';
export const UPDATE_THREEDS_DATA_FOR_CHALLENGE_IFRAME = 'UPDATE_THREEDS_DATA_FOR_CHALLENGE_IFRAME';

/* EXPRESS CHECKOUT */
export const SET_USING_EXPRESS_CHECKOUT = 'SET_USING_EXPRESS_CHECKOUT';
export const UPDATE_CLIENT_ID_LIST = 'UPDATE_CLIENT_ID_LIST';

/* GIFTCARD */
export const SET_GIFTCARD_AVAILABILITY = 'SET_GIFTCARD_AVAILABILITY';
export const UPDATE_GIFTCARD_FORM = 'UPDATE_GIFTCARD_FORM';
export const CLEAR_GIFTCARD_FORM = 'CLEAR_GIFTCARD_FORM';
export const ADD_APPLIED_GIFTCARD_TO_STATE = 'ADD_APPLIED_GIFTCARD_TO_STATE';
export const SET_GIFTCARD_MESSAGE = 'SET_GIFTCARD_MESSAGE';

/* EDIT BASKET */
export const SET_EDIT_BASKET_VALIDATION_MESSAGE = 'SET_EDIT_BASKET_VALIDATION_MESSAGE';

/* RECAPTCHA */
export const SET_RECAPTCHA_STRATEGY = 'SET_RECAPTCHA_STRATEGY';
export const SET_RECAPTCHA_TOKEN = 'SET_RECAPTCHA_TOKEN';

/* ADYEN V2 */
export const SET_ADYEN_V2_SESSION_DATA = 'SET_ADYEN_V2_SESSION_DATA';
export const SET_ADYEN_V2_CHECKOUT = 'SET_ADYEN_V2_CHECKOUT';
export const SET_ADYEN_V2_PLACE_ORDER_DATA = 'SET_ADYEN_V2_PLACE_ORDER_DATA';

/* OPTTY */
export const SET_OPTTY_SESSION_DATA = 'SET_OPTTY_SESSION_DATA';
